export default {
  laya: 'The digital learning platform for inclusive learning',
  imprint: 'imprint',
  privacy: 'privacy'
}



// WEBPACK FOOTER //
// ./src/i18n/footer/en.js